export * from './layer-legend.component';



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/lib/layer/layer-legend/index.ts